import { Home, BookOpen, Briefcase, Church, ArrowUpRight } from 'lucide-react';
import { AUDIENCES } from '@/lib/brand';
import Reveal from '@/components/Reveal';

const ICONS = { home: Home, book: BookOpen, briefcase: Briefcase, church: Church };

export default function WhoWeServe() {
  return (
    <section
      id="who-we-serve"
      data-testid="who-we-serve-section"
      className="relative bg-[#0E2238] py-24 md:py-36 overflow-hidden"
    >
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] rounded-full opacity-30 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(182,138,53,0.18) 0%, transparent 70%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <Reveal>
            <div className="overline text-[#D6B36A] mb-6 justify-center inline-flex">Who We Serve</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-6">
              Strategies for the Lives<br />
              You <span className="gold-text italic">Build For</span>.
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="text-white/60 text-base md:text-lg font-light leading-relaxed">
              Our clients come from different walks of life. What they share is a commitment to
              legacy, responsibility, and clarity.
            </p>
          </Reveal>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {AUDIENCES.map((a, i) => {
            const Icon = ICONS[a.icon];
            return (
              <Reveal key={a.key} delay={i * 130}>
                <div
                  data-testid={`audience-card-${a.key}`}
                  className="card-navy relative group overflow-hidden h-full"
                >
                  <div className="relative h-64 md:h-72 w-full overflow-hidden">
                    <img
                      src={a.image}
                      alt={a.title}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-[1400ms] group-hover:scale-[1.08]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0E2238] via-[#0E2238]/55 to-[#0E2238]/15" />
                    <div className="absolute top-6 left-6 w-12 h-12 rounded-sm border border-[#B68A35]/60 flex items-center justify-center bg-[#070B12]/70 backdrop-blur">
                      <Icon className="w-5 h-5 text-[#D6B36A]" strokeWidth={1.5} />
                    </div>
                    <span className="absolute top-6 right-6 font-serif text-white/40 text-3xl leading-none">0{i + 1}</span>
                  </div>

                  <div className="p-8 md:p-10">
                    <h3 className="font-serif text-white text-2xl md:text-3xl mb-4 tracking-tight">
                      {a.title}
                    </h3>
                    <p className="text-white/65 text-base leading-relaxed font-light mb-6">
                      {a.copy}
                    </p>
                    <div className="flex items-center gap-2 text-[#D6B36A] text-xs tracking-[0.22em] uppercase group-hover:gap-3 transition-all duration-500">
                      <span>Explore Fit</span>
                      <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
